export default __webpack_public_path__ + "static/WhiteStar-b79c040869683395e0d1f24e2abd214d.png";